{
  "cellsGapPx": 8,
  "cellHeaderHeightPx": 24
}
